import Dexie, { type EntityTable } from 'dexie';

import {
  LengthOfDiabetesDiagnosisEnum,
  TimeSinceLastEyeExamEnum,
  TypeOfDiabetesEnum,
} from 'src/models/DiabetesData.model';
import { OrderStatusEnum } from 'src/models/GalenData/Order.model';
import { Result } from 'src/models/Result.model';

export enum UploadStateEnum {
  NOT_STARTED = 'not-started',
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export enum ExamStepEnum {
  DIABETES_DATA = 'diabetes-data',
  EXAM_HINT = 'exam-hint',
  IMAGING = 'imaging',
  ANALYSIS = 'analysis',
}

export interface Exam {
  ExamId: string;
  LeftEyeImage?: Blob;
  LeftEyeFileName?: string;
  LeftEyeUploadStatus: UploadStateEnum;
  RightEyeImage?: Blob;
  RightEyeFileName?: string;
  RightEyeUploadStatus: UploadStateEnum;
  ExamUploadStatus: UploadStateEnum;
  ExamCreatedInGalen?: boolean;
  UpdatedAt: Date;
  TypeOfDiabetes?: TypeOfDiabetesEnum;
  LengthOfDiabetesDiagnosis?: LengthOfDiabetesDiagnosisEnum;
  TimeSinceLastEyeExam?: TimeSinceLastEyeExamEnum;
  LeftEyeMainGain?: number;
  LeftEyeSideGain?: number;
  RightEyeMainGain?: number;
  RightEyeSideGain?: number;
  CameraSn?: string;
  CameraVersion?: string;
  SubmittedForAnalysis?: boolean;
  LeftEyeResults?: Result[];
  RightEyeResults?: Result[];
  ResultPollingStatus?: UploadStateEnum;
}

export const examHasResults = (exam?: Exam): boolean =>
  !!exam?.LeftEyeResults?.length || !!exam?.RightEyeResults?.length;

export interface OrderIDB {
  OrderId: string;
  OrderUploadStatus: UploadStateEnum;
  OrderStatus: OrderStatusEnum;
  SiteId?: string;
  LeftImageAttempts: number;
  RightImageAttempts: number;
  LeftSubmissions: number;
  RightSubmissions: number;
  CreatedAt: Date;
  UpdatedAt: Date;
  Exams: Exam[];
  LastStep?: ExamStepEnum;
}

export const outboxDb = new Dexie(
  'optain-offline-examOrder-outbox',
) as Dexie & {
  orders: EntityTable<OrderIDB, 'OrderId'>;
};

outboxDb.version(1).stores({
  orders: 'OrderId, OrderUploadStatus, UpdatedAt',
});
